
import { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'

import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Table from 'react-bootstrap/Table'
import Container from 'react-bootstrap/Container'
import { backendAccessGet, backendAccessPost } from '../Utils/Authentication'

import { FaRegTrashAlt } from "react-icons/fa";
import { FaRegEdit } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { CheckGroup } from "./Misc"
import InputGroup from 'react-bootstrap/InputGroup'

import dayjs from "dayjs";
import { Stack, Chip } from "@mui/material";

function get_dict( dict, key, default_value )
{
    return ( dict[key] ) ? dict[key] : default_value
}

export function MultiDatePicker() {
    const [selectedDates, setSelectedDates] = useState([]);

    const handleDateChange = (newDate) => {
        const formattedDate = dayjs(newDate).format("YYYY-MM-DD");
        setSelectedDates((prevDates) =>
            prevDates.includes(formattedDate)
                ? prevDates.filter((date) => date !== formattedDate) // Remove if already selected
                : [...prevDates, formattedDate] // Add if new
        );
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack spacing={2}>
                <DatePicker onChange={handleDateChange} />
                <Stack direction="row" spacing={1}>
                    {selectedDates.map((date) => (
                        <Chip
                            key={date}
                            label={date}
                            onDelete={() =>
                                setSelectedDates(selectedDates.filter((d) => d !== date))
                            }
                        />
                    ))}
                </Stack>
                <Button variant="contained" onClick={() => console.log(selectedDates)}>
                    Submit Dates
                </Button>
            </Stack>
        </LocalizationProvider>
    );
}

const applications = [
    {name:'DP',var:'planner::daily'},
    {name:'RP',var:'planner::rotations'}
]

export function ApplicationView( props ) {
    const cfg = props.cfg

    return (
        <div className="d-flex justify-content-center" style={{ width:'100%' }}>
            { applications.map( (app,app_idx) => 
                <>
                { cfg[app.var] &&
                <div style={{ marginRight:'5px'}} >
                    <b>{ app.name }</b>
                </div>
                }
                { !cfg[app.var] &&
                <div style={{ marginRight:'5px'}} >
                    { app.name }
                </div>
                }

                </>
            )}
        </div>
    )
}

export function AddStaffModal(props) {
    const setShowAddModal = props.setShowAddModal
    const setStaff = props.setStaff

    const [firstname, setFirstname] = useState("")
    const [lastname, setLastname] = useState("")
    const [uid, setUid] = useState("")

    const [appRotation, setAppRotation] = useState(false)
    const [appDaily, setAppDaily] = useState(false)


    const addStaff = () => {
        if (firstname == "" || lastname == "") {
            return
        }

        let data = {}
        data.firstname = firstname
        data.lastname = lastname
        data.uid = uid
        data.applications = { 'planner::rotations': appRotation, 'planner::daily': appDaily }

        backendAccessPost('/api/staff/add/', data).then(res => {
            if (res.error_message) {
                alert(res.error_message)
            }

            setStaff(res.staff)
            setShowAddModal(false)
        })
    }

    return (
        <>
            <Modal.Header closeButton>
                <Modal.Title>Add staff</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Control style={{ marginBottom: '5px' }} placeHolder="Firstname"
                    value={firstname} onChange={e => setFirstname(e.target.value)} />
                <Form.Control style={{ marginBottom: '5px' }} placeHolder="Lastname"
                    value={lastname} onChange={e => setLastname(e.target.value)} />
                <Form.Control style={{ marginBottom: '5px' }} placeHolder="UID"
                    value={uid} onChange={e => setUid(e.target.value)} />
                <div style={{ width: '100%', padding: '10px' }}>
                    <div>
                        Applications
                    </div>
                    <Form.Check type="Checkbox" label="Rotation Planner"
                        value={appRotation} onChange={e => setAppRotation(e.target.checked)} />
                    <Form.Check type="Checkbox" label="Daily Planner"
                        value={appDaily} onChange={e => setAppDaily(e.target.checked)} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" onClick={e => setShowAddModal(false)}>Cancel</Button>
                <Button size="sm" onClick={addStaff}>Add</Button>
            </Modal.Footer>
        </>
    )
}

export function EditSection(props) {
    const name = props.name

    return (
        <>
            <div style={{ padding: '10px', borderRadius: '5px', marginTop: '10px' }}>
                <b>{name}</b>
            </div>
            <div style={{ padding: '10px', backgroundColor: '#fff', borderRadius: '5px', marginTop: '10px' }}>
                {props.children}
            </div>
        </>
    )
}

export function EditStaffModal(props) {
    const showModal = props.showModal
    const setShowModal = props.setShowModal
    const setStaff = props.setStaff
    const info = props.info

    const [firstname, setFirstname] = useState(null)
    const [lastname, setLastname] = useState(null)
    const [uid, setUid] = useState(null)
    const [roles, setRoles] = useState(null)
    const [departments,setDepartments] = useState(null)

    const [appRotation, setAppRotation] = useState(null)
    const [appDaily, setAppDaily] = useState(null)

    const [rolesSelected, setRolesSelected] = useState([])
    const [rotationsData, setRotationsData] = useState([])
    
    useEffect(() => {
        if (!showModal) {
            return;
        }

        var data = {}
        data.uid = info.uid

        backendAccessPost('/api/staff/fetch-data/',data).then( res => {
            if (res.error_message) {
                alert(res.error_message)
                return
            }

            let ii = res.info 
            setFirstname(ii.firstname)
            setLastname(ii.lastname)
            setUid(ii.uid)
            setAppRotation(get_dict(ii.applications,'planner::rotations',false))
            setAppDaily(get_dict(ii.applications,'planner::daily',false))
            setDepartments(res.departments)
            setRoles(res.roles)

            if( res.data_daily.roles )
            {
                setRolesSelected( res.data_daily.roles )
            }
            else 
            {
                setRolesSelected([])
            }
            setRotationsData(res.data_rotations)
        })

        //Initialize
    }, [showModal])

    const getFulfilled = (dep) => {
        if (!rotationsData.fulfillment) {
            rotationsData.fulfillment = {};
        }

        if (!(dep.uid in rotationsData.fulfillment)) {
            rotationsData.fulfillment[dep.uid] = {
                quota: dep.quota,
                fulfilled: 0,
            };
            setRotationsData({ ...rotationsData });
        }

        return rotationsData.fulfillment[dep.uid].fulfilled;
    }

    const setFulfilled = ( dep, val ) => {
        let dd = structuredClone(rotationsData)
        if( !( dep.uid in dd.fulfillment ) )
        {
            var d = {}
            d['quota'] = dep.quota
            d['fulfilled'] = 0

            dd.fulfillment[ dep.uid ] = d
        }

        dd.fulfillment[dep.uid]['fulfilled'] = parseInt(val)
        setRotationsData(dd)
    }

    const getQuota = (dep) => {
        if (!rotationsData.fulfillment) {
            rotationsData.fulfillment = {};
        }

        if (!(dep.uid in rotationsData.fulfillment)) {
            rotationsData.fulfillment[dep.uid] = {
                quota: dep.quota,
                fulfilled: 0,
            };
            setRotationsData({ ...rotationsData });
        }

        return rotationsData.fulfillment[dep.uid].quota;
    }

    const setQuota = ( dep, quota ) => {
        let dd = structuredClone(rotationsData)
        if( !( dep.uid in dd.fulfillment ) )
        {
            var d = {}
            d['quota'] = dep.quota
            d['fulfilled'] = 0

            dd.fulfillment[ dep.uid ] = d
        }

        dd.fulfillment[dep.uid]['quota'] = parseInt(quota)

        setRotationsData(dd)
    }

    const updateStaff = () => {
        if (firstname == "" || lastname == "") {
            return
        }

        let data = {}
        data.firstname = firstname
        data.lastname = lastname
        data.uid = uid
        data.applications = { 'planner::rotations': appRotation, 'planner::daily': appDaily }

        data.data_daily = {}
        data.data_daily.roles = structuredClone(rolesSelected)

        data.data_rotations = structuredClone(rotationsData)

        backendAccessPost('/api/staff/update-data/', data).then( res => {
            if( res.error_message )
            {
                alert(res.error_message)
                return
            }

            setStaff(res.staff)
            setShowModal(false)
        })
    }

    return (
        <Modal show={showModal} onHide={e => setShowModal(false)} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Edit staff</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{
                padding: '20px',
                backgroundColor: '#f6f6f6',
                maxHeight: '60vh',
                overflowY: 'auto'
            }}>                <EditSection name="General">
                    <Form.Control style={{ marginBottom: '5px' }} placeHolder="Firstname"
                        value={firstname} onChange={e => setFirstname(e.target.value)} />
                    <Form.Control style={{ marginBottom: '5px' }} placeHolder="Lastname"
                        value={lastname} onChange={e => setLastname(e.target.value)} />
                    <Form.Control style={{ marginBottom: '5px' }} placeHolder="UID"
                        value={uid} onChange={e => setUid(e.target.value)} disabled />
                    <div style={{ width: '100%', padding: '10px' }}>
                        <div>
                            Applications
                        </div>
                        <Form.Check type="Checkbox" label="Rotation Planner"
                            checked={appRotation} onChange={e => setAppRotation(e.target.checked)} />
                        <Form.Check type="Checkbox" label="Daily Planner"
                            checked={appDaily} onChange={e => setAppDaily(e.target.checked)} />
                    </div>
                </EditSection>
                <EditSection name="Daily Planer">
                    <div>
                        { (roles && rolesSelected) &&
                        <CheckGroup items={roles} selected={rolesSelected} setSelected={setRolesSelected} />
                        }
                    </div>
                </EditSection>
                <EditSection name="Rotation Planner">
                    {(rotationsData&& departments) &&
                        <>
                            {departments.map((d, idx) =>
                                <div style={{ marginBottom: '10px' }}>
                                    <div>
                                        {d.name}
                                    </div>
                                    <div>
                                        <InputGroup style={{ width: '100%' }} size="sm">
                                            <InputGroup.Text>Quota</InputGroup.Text>
                                            <Form.Control value={getQuota(d)} placeholder="Enter quota"
                                                          onChange={ e => setQuota(d, e.target.value ) }
                                            />
                                            <InputGroup.Text>Fulfilled</InputGroup.Text>
                                            <Form.Control value={getFulfilled(d)}
                                                          onChange={ e => setFulfilled(d, e.target.value ) }
                                            />
                                        </InputGroup>
                                    </div>
                                </div>
                            )}
                        </>
                    }
                </EditSection>
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" onClick={e => setShowModal(false)}>Cancel</Button>
                <Button size="sm" onClick={updateStaff}>Update</Button>
            </Modal.Footer>
        </Modal>
    )
}

export function VacationModal(props) {
    const showModal = props.showModal
    const setShowModal = props.setShowModal
    const info = props.info

    const [date, setDate] = useState(null)
    //const [ vacation, setVacation ] = useState([])

    const [selectedDates, setSelectedDates] = useState([])

    /*const setStaff = props.setStaff
    const info = props.info

    const [ firstname, setFirstname ] = useState(info.firstname)
    const [ lastname, setLastname ] = useState(info.lastname)
    const [ uid, setUid ] = useState(info.uid)

    const [ appRotation, setAppRotation ] = useState(info.applications.rotation)
    const [ appDaily, setAppDaily ] = useState(info.applications.daily)

    const updateStaff = () => {
        if( firstname == "" || lastname == "" )
        {
            return 
        }

        let data = {}
        data.firstname = firstname 
        data.lastname = lastname 
        data.uid = uid 
        data.applications = {'rotation':appRotation, 'daily':appDaily}

        backendAccessPost('/api/staff/update/', data).then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
            }

            setStaff( res.staff )
            setShowEditModal(false)
        })
    }*/

    useEffect(() => {
        if (showModal) {
            let data = {}
            data['uid'] = info.uid

            backendAccessPost('/api/staff/get-vacations/', data).then(res => {
                if (res.error_message) {
                    alert(res.error_message)
                    return
                }

                setSelectedDates(res.vacation)
            })
        }
    }, [showModal])

    /*const updateDate = ( newDate ) => {
        if( newDate == null )
        {
            return
        }

        setDate( newDate )
    }
    
    const addVacation = () => {
        if( date == null )
        {
            return 
        }

        let year = date.c.year.toString()
        let month = date.c.month.toString().padStart(2,'0')
        let day = date.c.day.toString().padStart(2,'0')

        let date_str = year + month + day
        
        let data = {}
        data['date'] = date_str 
        data['uid'] = info.uid 

        backendAccessPost('/api/staff/add-vacation/', data).then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
                return
            }

            setVacation(res.vacation)
        })
    }*/

    const removeVacation = (date_str) => {
        let data = {}
        data['date'] = date_str
        data['uid'] = info.uid

        console.log(data)

        backendAccessPost('/api/staff/remove-vacation/', data).then(res => {
            if (res.error_message) {
                alert(res.error_message)
                return
            }

            setSelectedDates(res.vacation)
        })

    }

    const addVacation = (newDate) => {
        const date_str = dayjs(newDate).format("YYYYMMDD");

        let data = {}
        data['date'] = date_str
        data['uid'] = info.uid

        backendAccessPost('/api/staff/add-vacation/', data).then(res => {
            if (res.error_message) {
                alert(res.error_message)
                return
            }

            setSelectedDates(res.vacation)
        })
    };

    return (
        <>
            <Modal.Header closeButton>
                <Modal.Title>Vacation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ padding: '5px' }}>
                    <div style={{ width: '300px', float: 'left' }}>
                        <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="de">
                            <StaticDatePicker size="small" onChange={addVacation}
                                slotProps={{ actionBar: { actions: [] } }} />
                        </LocalizationProvider>
                    </div>
                    <div style={{ width: 'calc(100% - 300px)', float: 'left' }}>
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                flexWrap: "wrap",
                                maxWidth: '100%', // Adjust max width for wrapping
                                justifyContent: "center",
                            }}
                        >
                            {selectedDates.map((date) => (
                                <Chip
                                    key={date}
                                    label={date}
                                    onDelete={() => removeVacation(date)}
                                    size="small"
                                />
                            ))}
                        </Stack>
                    </div>
                </div>

                {/*
                <div style={{ padding:'5px'}}>
                    <Button size="sm" onClick={addVacation} style={{ marginRight:'5px' }}>Add vacation</Button>
                    <Button size="sm" onClick={removeVacation}>Remove vacation</Button>
                </div>

                <hr />

                <div>
                    { vacation.map( (v,idx) => 
                    <div>
                        { v } [<a href="#" onClick={ e => removeVacation(v)}>Remove</a>]
                    </div>
                    )}
                </div>*/}
                {/*
                <Form.Control style={{ marginBottom:'5px'}} placeHolder="Firstname"
                              value={firstname} onChange={ e => setFirstname(e.target.value)} />
                <Form.Control style={{ marginBottom:'5px'}} placeHolder="Lastname"
                              value={lastname} onChange={ e => setLastname(e.target.value)} />
                <Form.Control style={{ marginBottom:'5px'}} placeHolder="UID"
                              value={uid} onChange={ e => setUid(e.target.value)} disabled/>
                <div style={{ width:'100%', padding:'10px'}}>
                    <div>
                        Applications
                    </div>
                    <Form.Check type="Checkbox" label="Rotation Planner" 
                                checked={appRotation} onChange={ e => setAppRotation(e.target.checked)}/>
                    <Form.Check type="Checkbox" label="Daily Planner"
                                checked={appDaily} onChange={ e => setAppDaily(e.target.checked)}/>         
                </div>*/}
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" onClick={e => setShowModal(false)}>Close</Button>
                {/*<Button size="sm" onClick={updateStaff}>Update</Button>*/}
            </Modal.Footer>
        </>
    )
}


export function StaffRow(props) {
    const info = props.info
    const index = props.index
    const setStaff = props.setStaff
    const editStaff = props.editStaff
    const openVacation = props.openVacation

    const removeStaff = () => {
        if (!window.confirm('Are you sure you want to delete?')) {
            return
        }

        let data = { uid: info.uid }
        backendAccessPost('/api/staff/remove/', data).then(res => {
            if (res.error_message) {
                alert(res.error_message)
                return
            }

            setStaff(res.staff)

        })
    }

    return (
        <tr>
            <td>{index + 1}</td>
            <td>{info.firstname} <b>{info.lastname}</b></td>
            <td>{info.uid}</td>
            <td>
                {info.status}
            </td>
            <td>
                <ApplicationView cfg={info.applications}/>
            </td>
            <td>
                <FaRegEdit style={{ cursor: 'pointer', marginRight: '5px' }} onClick={e => editStaff(index)} />
                <FaCalendarAlt style={{ cursor: 'pointer', marginRight: '5px' }} onClick={e => openVacation(index)} />
                <FaRegTrashAlt style={{ cursor: 'pointer' }} onClick={removeStaff} />
            </td>
        </tr>

    )
}

export default function Staff() {
    const [staff, setStaff] = useState([])
    const [showAddModal, setShowAddModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [showVacationModal, setShowVacationModal] = useState(false)
    const [roles, setRoles] = useState([])
    const [departments, setDepartments] = useState([])

    const editIdx = useRef(null)
    const vacationIdx = useRef(null)
    useEffect(() => {
        let data = {}
        backendAccessPost('/api/staff/fetch/', data).then(res => {
            if (res.error_message) {
                alert(res.error_message)
                return
            }

            setStaff(res.staff)
            setRoles(res.roles)
            setDepartments(res.departments)
        })

    }, [])


    /*backendAccessGet('/api/planner/rotations/residents/fetch/').then(res => {
        if ('error_message' in res) {
            alert(res['error_message'])
            return
        }

        // setPositions( res.positions )
        setDepartments(res.departments)
        // setResidents( res.residents )
    })*/

    /*useEffect(() => {
        let data = {}
        backendAccessGet('/api/planner/daily/staff/fetch/').then(res => {
            if (res.error_message) {
                alert(res.error_message)
                return
            }

            setRoles(res.roles)
        })

    }, [])*/



    const openAddModal = () => {
        setShowAddModal(true)
    }

    const editStaff = (idx) => {
        editIdx.current = idx
        setShowEditModal(true)
    }

    const openVacation = (idx) => {
        vacationIdx.current = idx
        setShowVacationModal(true)
    }

    return (
        <>
            <Helmet>
                <title> Clinic Manager | Staff </title>
            </Helmet>

            <Container style={{ height: 'calc(100vh - 60px)', maxWidth: '1000px', overflowY: 'scroll' }}>
                <div className="d-flex justify-content-center"
                    style={{ width: '100%', padding: '10px' }}
                >
                    <Button size="sm" onClick={openAddModal}>Add</Button>
                </div>
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Unique ID</th>
                            <th>Status</th>
                            <th>Applications</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {staff.map((s, idx) =>
                            <StaffRow info={s} index={idx} key={idx} setStaff={setStaff} editStaff={editStaff} openVacation={openVacation} />
                        )}
                    </tbody>
                </Table>
            </Container>

            <Modal show={showAddModal} onHide={e => setShowAddModal(false)}>
                {showAddModal &&
                    <AddStaffModal setShowAddModal={setShowAddModal}
                        setStaff={setStaff}
                    />
                }
            </Modal>

            {staff.length > 0 &&
                <EditStaffModal showModal={showEditModal} setShowModal={setShowEditModal}
                    setStaff={setStaff}
                    staff={staff}
                    info={staff[editIdx.current]}
                />
            }



            <Modal show={showVacationModal} onHide={e => setShowVacationModal(false)} size="lg">
                <VacationModal showModal={setShowVacationModal}
                    setShowModal={setShowVacationModal}
                    info={staff[vacationIdx.current]}
                />
            </Modal>

        </>
    )
}


